var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import LoadingSpinner from "../LoadingSpinner";
var LoadingButton = function (_a) {
    var isLoading = _a.isLoading, onClick = _a.onClick, children = _a.children, _b = _a.type, type = _b === void 0 ? "button" : _b, _c = _a.color, color = _c === void 0 ? "primary" : _c, _d = _a.className, className = _d === void 0 ? "" : _d, _e = _a.form, form = _e === void 0 ? null : _e;
    var formProps = form ? { form: form } : {};
    return (_jsx("button", __assign({ className: "btn-".concat(color, " ").concat(className), onClick: onClick, disabled: isLoading, type: type }, formProps, { children: isLoading ? _jsx(LoadingSpinner, { className: "mx-auto" }) : children })));
};
export default LoadingButton;
